import React , {useState,useEffect} from 'react'
import axios from "axios";
import { ReactSession } from "react-client-session";
import './BaaHam_NormalUsers_SabteAgahi.css'
import SabteAgahi_DropDown from './SabteAgahi_DropDown'
import { styled } from '@mui/system';
import SwitchUnstyled, { switchUnstyledClasses } from '@mui/base/SwitchUnstyled';
import Select from 'react-select'
import { useMediaQuery } from 'react-responsive'
import image1 from '../../../../pic1.jpg'
import {BiImageAdd} from 'react-icons/bi'



const blue = {
  500: '#007FFF',
};

const grey = {
  400: '#BFC7CF',
  500: '#AAB4BE',
  600: '#6F7E8C',
};

const Root = styled('span')(
  ({ theme }) => `
  font-size: 0;
  position: relative;
  display: inline-block;
  width: 30px;
  height: 16px;

  cursor: pointer;

  &.${switchUnstyledClasses.disabled} {
    opacity: 0.4;
    cursor: not-allowed;
  }

  & .${switchUnstyledClasses.track} {
    background: ${theme.palette.mode === 'dark' ? grey[600] : grey[400]};
    border-radius: 10px;
    display: block;
    height: 100%;
    width: 100%;
    position: absolute;
  }

  & .${switchUnstyledClasses.thumb} {
    display: block;
    width: 13px;
    height: 13px;
    top: 1.5px;
    left: 1.5px;
    border-radius: 16px;
    background-color: #fff;
    position: relative;
    transition: all 200ms ease;
  }

  &.${switchUnstyledClasses.focusVisible} .${switchUnstyledClasses.thumb} {
    background-color: ${grey[500]};
    box-shadow: 0 0 1px 8px rgba(0, 0, 0, 0.25);
  }

  &.${switchUnstyledClasses.checked} {
    .${switchUnstyledClasses.thumb} {
      left: 15px;
      top: 1.5px;
      background-color: #fff;
    }

    .${switchUnstyledClasses.track} {
      background: ${blue[500]};
    }
  }

  & .${switchUnstyledClasses.input} {
    cursor: inherit;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
    margin: 0;
  }
  `,
);




function BaaHam_NormalUsers_SabteAgahi() {
  ReactSession.setStoreType("localStorage");
  const UserId = ReactSession.get("UserId");
  const UserType = ReactSession.get("UserType");
  const UserPhoneNumber = ReactSession.get("UserPhoneNumber");

  useEffect(() => {
    window.scrollTo(0,0);
  });


  const [ImageSrcs , setImageSrc] = useState([]);
  const HandlesetImageSrc = (e) => {
    let temp = ImageSrcs;
    temp.push(e);
    setImageSrc(temp);
  }
  

  const q1380 = useMediaQuery({ query: '(max-width: 1380px)' })
  const q1230 = useMediaQuery({ query: '(max-width: 1230px)' })
  const q920 = useMediaQuery({ query: '(max-width: 920px)' })
  const q775 = useMediaQuery({ query: '(max-width: 775px)' })
  const q715 = useMediaQuery({ query: '(max-width: 715px)' })
  let fontSizeRes = "13px";
  let selectWidth ="275px"
  if (q1380) {
    selectWidth = "245px"
  }


  if (q1230) {
    selectWidth = "200px"
  }
  if (q920) {
    fontSizeRes="11px"
  }
  if (q775 ) {
    fontSizeRes = "9.5px"
  }
  if (q715 ) {
    fontSizeRes = "11px"
  }
  const res500 = useMediaQuery({ query: '(max-width: 500px)' })
  const res600 = useMediaQuery({ query: '(max-width: 600px)' })
  const res700 = useMediaQuery({ query: '(max-width: 700px)' })
  const [AgahiSwitch, setAgahiSwitch] = useState(1);
  let selectHeight = "36px";
  if (res700) {
      selectHeight = "30px"
  }

const customStyles = {
  
  control: (base, state) => ({
    ...base,
    /*borderColor: state.isFocused ? "yellow" : "green",
    "&:hover": {
      borderColor: state.isFocused ? "red" : "blue"
    }*/
    minHeight:selectHeight,
    height:selectHeight,
    width:'100%',
    border:'none',
    borderRadius:"10px",
    backgroundColor:'rgb(245, 245, 245)',
    "&:hover": {
      borderColor: "#d1d1d1"
    },
    '&:focus':{
      borderColor: "#d1d1d1"
    },
    "&:active":{ 
      borderColor: "#d1d1d1"
    },
    display:'flex',
  }),
  option: (provided, state) => ({
      ...provided,

  }),
  indicatorSeparator: (styles) => ({display:'none'}),
  singleValue: (provided) => ({
    ...provided,
    color: 'rgb(98, 98, 98)',
    fontSize:res500?'8px' :res600?'9px' : res700?'10px':'12px',
    display:'flex',
    
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: selectHeight,
    padding: '0 6px',

    display:'flex',
    fontSize:fontSizeRes,
    color: 'rgb(178, 178, 178)',
    fontWeight : 'bold'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height:selectHeight,
  }),
  
  dropdownIndicator: base => ({
    ...base,
    fontSize:res600?'6px' : '8px',

    "&:hover": {
      color: "#5843b1" 
    },
    paddingTop: 2,
    paddingBottom:2 ,
  }),
  clearIndicator: (styles) => ({
    ...styles,
    paddingTop: 2,
    paddingBottom: 2,
  }),
  menu: base => ({
    ...base,
    // override border radius to match the box
    borderRadius: 0,
    // kill the gap
    marginTop: 0
  }),   
 
};



  const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const optionsList1 = [
      { label: 'Option 1', value: 'Option 1'},
      { label: 'Option 2', value: 'Option 2'},
      { label: 'Option 3', value: 'Option 3'},
      { label: 'Option 4', value: 'Option 4'},
  ];
  const label = { componentsProps: { input: { 'aria-label': 'Demo switch' } } };
  
  const settest2 = () => {
    console.log("hi");
    window.scrollTo(0,0)
  }

//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
  const [stateList, setStateList] = React.useState([]);
  useEffect(() => {
      axios
          .get("https://hammaskan.ir:8443/api/locations/states")
          .then((res) => {
              // console.log(res.data.data);
              // console.log(res.data.data[0].state);
              var states = [];
              // console.log(states);
              res.data.data.forEach((item, index)=>{
                  // console.log(item);
                  states.push({ label: item.state, value: item.state});
                  setStateList(states);
              })
          })
          .catch((error) => {
              // console.log(error);
              // window.location.href = "./Account";
          });
  }, []);


  const [cityList, setCityList] = React.useState([]);
  const [citySelectValue, setCitySelectValue] = React.useState(null);

  function handleChangeCity(event) {

    setCitySelectValue(null);

    var stateName = event.value;
    console.log(stateName);
    axios
    .get("https://hammaskan.ir:8443/api/locations/cityName?stateName="+ stateName)
    .then((res) => {
        console.log(res.data.data);
        // console.log(res.data.data[0].state);
        var cities = [];
        // // console.log(states);
        res.data.data.forEach((item, index)=>{
            // console.log(item);
            cities.push({ label: item.city, value: item.city});
            setCityList(cities);
        })
    })
    .catch((error) => {
        // console.log(error);
        // window.location.href = "./Account";
    });

  }
  const handleChangeCitySelect = (value) => {
    setCitySelectValue(value);
  };

  const [showGeoValue, setShowGeoValue] = React.useState(true);
  const showGeoChange = (event) => {
    setShowGeoValue(event.target.checked);
  };

  const [agahiImages, setAgahiImages] = React.useState([]);
  useEffect(() => {
    ImageSrcs.forEach((item, index)=>{
        if (index === ImageSrcs.length - 1){ 
          let reader = new FileReader();
          reader.readAsDataURL(ImageSrcs[index]);
          reader.onload = function () {
            axios({
                  url: "https://hammaskan.ir:8443/api/data/image/row",
                  method: "POST",
                  data: {
                      imageData: reader.result,
                      imageName: item.name,
                      dataType: item.type,
                      dataUseType: UserType,
                      dataOwnerId: UserId,
                  },
                  maxContentLength: "infinity",
                  maxBodyLength: "infinity",
                  })
                  .then((res) => {
                      console.log(res);
                      setAgahiImages([...agahiImages,res.data.data]);
                  })
                  .catch((error) => {
                      console.log(error);
                  });
          };
        };
      });
}, [ImageSrcs]);
  const removeAgahiImage = () => {
    setImageSrc([]);
    setAgahiImages([]);
  }

  const regAgahiCode = () => {
    var agahiCodeDialogWait = document.getElementById("agahiCodeDialogWait");
    var agahiCodeDialogOk = document.getElementById("agahiCodeDialogOk");
    var agahiCodeDialogErr = document.getElementById("agahiCodeDialogErr");

    agahiCodeDialogWait.style.display = "inline-block";
    agahiCodeDialogOk.style.display = "none";
    agahiCodeDialogErr.style.display = "none";
    axios
    .get("https://hammaskan.ir:8443/api/advertises/code/" + UserPhoneNumber)
    .then((res) => {
        agahiCodeDialogWait.style.display = "none";
        agahiCodeDialogOk.style.display = "inline-block";
        agahiCodeDialogErr.style.display = "none";
    })
    .catch((error) => {
        // console.log(error);
        agahiCodeDialogWait.style.display = "none";
        agahiCodeDialogOk.style.display = "none";
        agahiCodeDialogErr.style.display = "inline-block";
        if (error.response.data.message) {
          agahiCodeDialogErr.textContent = error.response.data.message;
        } else {
          agahiCodeDialogErr.textContent = "امکان ارسال پیامک وجود ندارد";
        }
    });
};

  const regAgahi = () => {
      var DialogWait = document.getElementById("labelLSGNDialogWait");
      var DialogOk = document.getElementById("labelLSGNDialogOk");
      var DialogErr = document.getElementById("labelLSGNDialogErr");
      DialogWait.style.display = "inline-block";
      DialogOk.style.display = "none";
      DialogErr.style.display = "none";

      var formValidate = true;
      
      var advertiseType = document.getElementById("advertiseType").textContent;
      if(advertiseType == "نوع آگهی"){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا نوع آگهی را مشخص نمایید";
      }   
      var advertiseUseType = document.getElementById("advertiseUseType").textContent;
      if(advertiseUseType == "نوع کاربری"){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا نوع کاربری آگهی را مشخص نمایید";
      }
      var buildingType = document.getElementById("buildingType").textContent;
      if(buildingType == "نوع ملک"){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا نوع ملک را مشخص نمایید";
      }
      var locationRange = document.getElementById("stateSelect").textContent;
      if(locationRange == "استان خود را انتخاب کنید"){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا استان خود را مشخص نمایید";
      }
      var city = document.getElementById("citySelect").textContent;
      if(city == "شهر خود را انتخاب کنید"){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا شهر خود را مشخص نمایید";
      }

      var showGeo = showGeoValue;

      var area = document.getElementById("area").value;
      if(!area){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا متراژ را وارد نمایید";
      }
      var deposit = document.getElementById("deposit").value;
      if(!deposit){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا مبلغ ودیعه را وارد نمایید";
      }
      var monthlyRent = document.getElementById("monthlyRent").value;
      if(!monthlyRent){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا مبلغ اجاره ماهانه را وارد نمایید";
      }
      var depositAndRent = document.getElementById("depositAndRent").value;
      if(!depositAndRent){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا مبلغ ودیعه و اجاره را وارد نمایید";
      }
      var suitableFor = document.getElementById("suitableFor").value;
      if(!suitableFor){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا فیلد مناسب برای ، را وارد نمایید";
      }
      var rooms = document.getElementById("rooms").value;
      if(!rooms){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا تعداد اتاق را وارد نمایید";
      }
      var yearOfConstruction = document.getElementById("yearOfConstruction").value;
      if(!yearOfConstruction){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا سال ساخت را وارد نمایید";
      }
      var floor = document.getElementById("floor").value;
      if(!floor){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا طبفه را وارد نمایید";
      }
      var elevator = document.getElementById("elevator").textContent;
      if(elevator == "لطفا وضعیت آسانسور را مشخص نمایید"){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا وضعیت آسانسور را مشخص نمایید";
      }
      var parking = document.getElementById("parking").textContent;
      if(parking == "لطفا وضعیت پارکینگ را مشخص نمایید"){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا وضعیت پارکینگ را مشخص نمایید";
      }
      var warehouse = document.getElementById("warehouse").textContent;
      if(warehouse == "لطفا وضعیت انباری را مشخص نمایید"){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا وضعیت انباری را مشخص نمایید";
      }

      var advertiseCode = document.getElementById("advertiseCode").value;
      if(!advertiseCode){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا کد تایید ثبت آگهی را وارد نمایید";
      }

      var title = document.getElementById("title").value;
      if(!title){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا عنوان آگهی را وارد نمایید";
      }
      var description = document.getElementById("description").value;
      if(!description){
        formValidate = false;
        DialogWait.style.display = "none";
        DialogOk.style.display = "none";
        DialogErr.style.display = "inline-block";
        DialogErr.textContent = "لطفا توضیحات آگهی را وارد نمایید";
      }

      if(
        advertiseType !== "نوع آگهی" && 
        advertiseUseType !== "نوع کاربری" &&
        buildingType !== "نوع ملک" &&
        locationRange !== "استان خود را انتخاب کنید" &&
        city !== "شهر خود را انتخاب کنید" &&
        area && deposit && monthlyRent && depositAndRent && suitableFor &&
        rooms && yearOfConstruction && floor && elevator && parking &&
        warehouse && advertiseCode && title && description && formValidate){
          



        // console.log(ImageSrcs);
        axios
          .post("https://hammaskan.ir:8443/api/advertises", {
              advertiseCode: advertiseCode,
              image : agahiImages,
              title: title,
              description: description,
              advertiseType: advertiseType,
              advertiseUseType: advertiseUseType,
              buildingType: buildingType,
              city: city,
              locationRange: locationRange,
              geoLatitude: "",
              geoLongitude: "",
              showGeo: showGeo,
              area: area,
              advertiserType: UserType,
              advertiserId: UserId,
              advertiserPhone: UserPhoneNumber,
              deposit: deposit,
              monthlyRent: monthlyRent,
              depositAndRent: depositAndRent,
              suitableFor: suitableFor,
              rooms: rooms,
              yearOfConstruction: yearOfConstruction,
              floor: floor,
              elevator: ((elevator == "دارد") ? true : false),
              parking: ((parking == "دارد") ? true : false),
              warehouse: ((warehouse == "دارد") ? true : false)
          })
          .then((res) => {
              setTimeout(() => {
                  DialogWait.style.display = "none";
                  DialogOk.style.display = "inline-block";
                  DialogErr.style.display = "none";
                  console.log(res);
              }, 300);
          })
          .catch((error) => {
              setTimeout(() => {
                  DialogWait.style.display = "none";
                  DialogOk.style.display = "none";
                  DialogErr.style.display = "inline-block";
                  if (error.response.data.message) {
                    DialogErr.textContent = error.response.data.message;
                  } else {
                    DialogErr.textContent = "در ذخیره سازی آگهی مشکلی وجود دارد";
                  }
              }, 300);
          });

      }
  };

  return (
    <div className='BaaHam_NormalUsers_SabteAgahi' id="scroller">
     
        <span className='BaaHam_NormalUsers_SabteAgahiTitle1'>ثبت آگهی</span>
        <div className='BaaHam_NU_SabteAgahiTopGrid'>
          <Select
            id="advertiseType"
            placeholder="نوع آگهی"
            styles={customStyles}
            options={[
                { label: 'خرید و فروش', value: 'خرید و فروش'},
                { label: 'رهن و اجاره', value: 'رهن و اجاره'}
            ]}
            >
          </Select>
          <Select
            id="advertiseUseType"
            placeholder="نوع کاربری"
            styles={customStyles}
            options={[
                { label: 'مسکونی', value: 'مسکونی'},
                { label: 'اداری تجاری', value: 'اداری تجاری'}
            ]}
            >
          </Select>
          <Select
            id="buildingType"
            placeholder="نوع ملک"
            styles={customStyles}
            options={[
                { label: 'آپارتمان / برج', value: 'آپارتمان / برج'},
                { label: 'ویلایی / باغ و باغچه', value: 'ویلایی / باغ و باغچه'},
                { label: 'پنت هاوس', value: 'پنت هاوس'},
                { label: 'مستغلات', value: 'مستغلات'},
                { label: 'زمین / کلنگی', value: 'زمین / کلنگی'},
                { label: 'سایر', value: 'سایر'}
            ]}
            >
          </Select>
          {/* <SabteAgahi_DropDown placeholder="اجاره مسکونی" optionsList={[
              { label: 'اجاره مسکونی', value: 'Egare-maskoni'},
              { label: 'فروش مسکونی', value: 'forosh-maskoni 2'},
              { label: 'اجاره اداری و تجاری', value: 'egare-edari'},
              { label: 'فروش اداری و تجاری', value: 'forosh-edari'},
              { label: 'اجاره کوتاه مدت', value: 'egare-kotah'},
              { label: 'پروژه های ساخت و ساز', value: 'sakht-o-saz'},
              { label: 'متفرقه', value: 'motefarege'},
          ]}/> */}
        </div>
        {/* <span className='BaaHam_NormalUsers_SabteAgahiTitle1'>ثبت آگهی / اجاره مسکونی</span>
        <div className='BaaHam_NU_SabteAgahiTopGrid'>
            <SabteAgahi_DropDown placeholder="آپارتمان"/>
            <SabteAgahi_DropDown placeholder="ویلا"/>
            <SabteAgahi_DropDown placeholder="متفرقه"/>
        </div> */}

        {/* <div className='BaaHam_NormalUsers_SabteAgahiButton1'>
          <span>آپارتمان</span>
        </div> */}
        <div className='BaaHam_NormalUsers_SabteAgahiTitle1Container'>
          <span className='BaaHam_NormalUsers_SabteAgahiTitle1'>ثبت آگهی /  </span>
          <span className='BaaHam_NormalUsers_SabteAgahiTitle1 BaaHam_NormalUsers_SabteAgahiTitle1Active'> موقعیت</span>
        </div>
        <div className='BaaHam_NormalUsers_SabteAgahiAreaContainer'>
          <div className='BaaHam_NormalUsers_SabteAgahiAreaSelects'>
              <div className='BaaHam_NormalUsers_SabteAgahiAreaSelect BaaHam_NormalUsers_SabteAgahiAreaSelectNoTopMargin'>
                <span className='BaaHam_NormalUsers_SabteAgahiAreaSelectTitle'> استان</span>
                <div className='BaaHam_NormalUsers_SabteAgahiAreaSelectContain'>
                  <Select
                    id="stateSelect"
                    placeholder="استان خود را انتخاب کنید"
                    styles={customStyles}
                    options={stateList}
                    onChange={handleChangeCity}
                    >
              
                  </Select>
                </div>
              </div>
              <div className='BaaHam_NormalUsers_SabteAgahiAreaSelect'>
                <span className='BaaHam_NormalUsers_SabteAgahiAreaSelectTitle'> شهر</span>
                <div className='BaaHam_NormalUsers_SabteAgahiAreaSelectContain'>
                  <Select
                    id="citySelect"
                    placeholder="شهر خود را انتخاب کنید"
                    styles={customStyles}
                    options={cityList}
                    value={citySelectValue}
                    onChange={handleChangeCitySelect}
                    >
              
                  </Select>
                </div>
              </div>
              <div className='BaaHam_NormalUsers_SabteAgahiAreaSelectSwitch'>
                <span className='BaaHam_NormalUsers_SabteAgahiAreaSelectSwitchTitle'>موقعیت دقیق نمایش داده شود</span>
                <div className='BaaHam_NormalUsers_SabteAgahiAreaSelectSwitchCotainer'>
                  <SwitchUnstyled id="showGeo" component={Root} {...label} defaultChecked onChange={showGeoChange} />
                </div>
 
              </div>
          </div>
          {/* <div className='BaaHam_NormalUsers_SabteAgahiAreaMapContainer'>
            <span>انتخاب محدوده ملک روی نقشه</span>
          </div> */}
        </div>
        <div className='BaaHam_NU_SabteAgahiPicsBigContainer'>         
          <span className='BaaHam_NormalUsers_SabteAgahiAreaSelectTitle'>عکس آگهی</span>
          <span className='BaaHam_NormalUsers_SabteAgahiTitle1 BaaHam_NU_SabteAgahiPicsTitle'>عکس هایی از داخل و بیرون ملک اضافه کنید.آگهی های دارای عکس تا ((3 برابر)) بیشتر توسط کاربران دیده میشوند.</span>
          <div className="BaaHam_NU_SabteAgahiPicsContainer">

              <div className="waitforimage">
              <input className="imageInput" id="Imageinput" type="file" onChange = {(e) => setImageSrc([...ImageSrcs,e.target.files[0]])} />
              <label className="ImageInputLabel" htmlFor="Imageinput"><BiImageAdd /></label>             
              </div>
              {ImageSrcs.map((ImageSrc) => {
                  return (
                      <img className="BaaHam_NU_SabteAgahiPic" alt="" src={URL.createObjectURL(ImageSrc)} onClick={removeAgahiImage} />      
                      )   
                } )
              }
          
          </div>
          <span className='BaaHam_NormalUsers_SabteAgahiTitle1 BaaHam_NU_SabteAgahiPicsTitle'> تعداد عکس های انتخاب شده نباید بیشتر از 20 باشد.</span>
        </div>
        <div className='BaaHam_NU_SabteAgahiBottomGrids'>
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>متراژ <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2'>
              <input type={"Number"} id="area" className='BaaHam_NU_SabteAgahiBottomGridInput'></input>
              </div>
            </div>
            {/* <div className='BaaHam_NU_SabteAgahiDahandeContainer'>
              <span className='BaaHam_NU_SabteAgahiDahandeContinerTitle'>آگهی دهنده :</span>
              <div className='BaaHam_NU_SabteAgahiDahandeContainerRes'>
                <div className='BaaHam_NU_SabteAgahiDahande BaaHam_NU_SabteAgahiDahandeRes'>
                  <div className={['BaaHam_NU_SabteAgahiDahandeCircle ',AgahiSwitch===1? "BaaHam_NU_SabteAgahiDahandeCircleActive" : ""].join(" ")} onClick={() => setAgahiSwitch(1)}>
                    <div className={['BaaHam_NU_SabteAgahiDahandeCircleIn BaaHam_NU_SabteAgahiDahandeCircleInExact',AgahiSwitch===1?'BaaHam_NU_SabteAgahiDahandeCircleInActive' : ""].join(" ")}></div>
                  </div>
                  <div className='BaaHam_NU_SabteAgahiDahandeTitle'>
                    <span >شخصی</span>
                  </div>
      
                </div>
                <div className='BaaHam_NU_SabteAgahiDahande'>
                  <div className={['BaaHam_NU_SabteAgahiDahandeCircle',AgahiSwitch===2? "BaaHam_NU_SabteAgahiDahandeCircleActive" : ""].join(" ")} onClick={() => setAgahiSwitch(2)}>
                    <div className={['BaaHam_NU_SabteAgahiDahandeCircleIn',AgahiSwitch===2?'BaaHam_NU_SabteAgahiDahandeCircleInActive' : ""].join(" ")}></div>
                  </div>
                  <div className='BaaHam_NU_SabteAgahiDahandeTitle'>
                    <span >مشاور املاک</span>
                  </div>

                </div>
              </div>
            </div> */}
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>ودیعه <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              
              <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2'>
                <input type={"Number"} id="deposit" className='BaaHam_NU_SabteAgahiBottomGridInput'></input>
              </div>
            </div>
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>اجاره ماهانه <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2'>
                <input type={"Number"} id="monthlyRent" className='BaaHam_NU_SabteAgahiBottomGridInput'></input>
              </div>
  
            </div>
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>ودیعه و اجاره <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2'>
                <input type={"Number"} id="depositAndRent" className='BaaHam_NU_SabteAgahiBottomGridInput'></input>
              </div>
            </div>
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>مناسب برای <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2'>
                <input id="suitableFor" className='BaaHam_NU_SabteAgahiBottomGridInput'></input>
              </div>
            </div>
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>تعداد اتاق <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2'>
                <input type={"Number"} id="rooms" className='BaaHam_NU_SabteAgahiBottomGridInput'></input>
              </div>
            </div>
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>سن بنا <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2'>
                <input id="yearOfConstruction" className='BaaHam_NU_SabteAgahiBottomGridInput'></input>
              </div>
            </div>      
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>طبقه <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2'>
                <input type={"Number"} id="floor" className='BaaHam_NU_SabteAgahiBottomGridInput'></input>
              </div>
            </div>     
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>آسانسور <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <div className='BaaHam_NormalUsers_SabteAgahiAreaSelectContain'>
                  <Select
                    id="elevator"
                    placeholder="لطفا وضعیت آسانسور را مشخص نمایید"
                    styles={customStyles}
                    options={[
                        { label: 'دارد', value: 'دارد'},
                        { label: 'ندارد', value: 'ندارد'}
                    ]}
                    >
                  </Select>
                {/* <input id="elevator" className='BaaHam_NU_SabteAgahiBottomGridInput'></input> */}
              </div>
            </div>
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>پارکینگ <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <div className='BaaHam_NormalUsers_SabteAgahiAreaSelectContain'>
                  <Select
                    id="parking"
                    placeholder="لطفا وضعیت پارکینگ را مشخص نمایید"
                    styles={customStyles}
                    options={[
                        { label: 'دارد', value: 'دارد'},
                        { label: 'ندارد', value: 'ندارد'}
                    ]}
                    >
                  </Select>
                {/* <input id="parking" className='BaaHam_NU_SabteAgahiBottomGridInput'></input> */}
              </div>
            </div>
            <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle'>انباری <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <div className='BaaHam_NormalUsers_SabteAgahiAreaSelectContain'>
                  <Select
                    id="warehouse"
                    placeholder="لطفا وضعیت انباری را مشخص نمایید"
                    styles={customStyles}
                    options={[
                        { label: 'دارد', value: 'دارد'},
                        { label: 'ندارد', value: 'ندارد'}
                    ]}
                    >
                  </Select>
                {/* <input id="warehouse" className='BaaHam_NU_SabteAgahiBottomGridInput'></input> */}
              </div>
            </div>
        </div>

        <div className='BaaHam_NU_SabteAgahiMoreFeaturesTitle'>
          <span>انتخاب سایر ویژگی ها و امکانات</span>
        </div>
        {/* <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle BaaHam_NU_SabteAgahiBottomGridTitleExact' >شماره موبایل <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <span className='BaaHam_NU_SabteAgahiBottomGridDescribe'>کد تایید به شماره موبایل شما ارسال خواهد شد. تماس و چت نیز با این شماره انجام می شود.</span>
              <span className='BaaHam_NU_SabteAgahiBottomGridDescribe'>توجه: لطفا پس از ثبت آگهی، به پیامک های پرداخت وجه بی اعتنا باشید.</span>
              <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2 BaaHam_NU_SabteAgahiBottomGridInputForBack2Agahi'>
                <input id="advertiserPhone" className='BaaHam_NU_SabteAgahiBottomGridInput2'></input>
              </div>
        </div> */}
      
        <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle BaaHam_NU_SabteAgahiBottomGridTitleExact' >کد تایید ثبت آگهی <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <span className='BaaHam_NU_SabteAgahiBottomGridDescribe'>کد تایید ثبت آگهی به شماره موبایل شما ارسال خواهد شد. تماس و چت نیز با این شماره انجام می شود.</span>
              <span className='BaaHam_NU_SabteAgahiBottomGridDescribe'>توجه: لطفا پس از ثبت آگهی، به پیامک های پرداخت وجه بی اعتنا باشید.</span>
              <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2 BaaHam_NU_SabteAgahiBottomGridInputForBack2Agahi'>
                <input id="advertiseCode" className='BaaHam_NU_SabteAgahiBottomGridInput2'></input>
              </div>
        </div>
        <div className="labelLSGN" id="agahiCodeDialogWait" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
            لطفا کمی صبر کنید ...
        </div>
        <div className="labelLSGN" id="agahiCodeDialogOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#06d6a0", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
            کد تایید ثبت آگهی به شماره تلفن شما ارسال شد
        </div>
        <div className="labelLSGN" id="agahiCodeDialogErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
            --
        </div>
        <div className='BaaHam_NU_SabteAgahiBottomButtons'>
          <div className='BaaHam_NU_SabteAgahiBottomButton ' onClick={regAgahiCode}>
            <span>دریافت کد ثبت</span>
          </div>
        </div>
        <div className='BaaHam_NU_SabteAgahiBottomGrid'>
          <span className='BaaHam_NU_SabteAgahiBottomGridTitle BaaHam_NU_SabteAgahiBottomGridTitleExact'>عنوان آگهی <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
          <span className='BaaHam_NU_SabteAgahiBottomGridDescribe'>در عنوان آگهی به موارد مهمی مانند نوع ملک، متراژ و محله اشاره کنید</span>
          <div className='BaaHam_NU_SabteAgahiBottomGridInputForBack2 BaaHam_NU_SabteAgahiBottomGridInputForBack2Agahi'>
            <input id="title"  className='BaaHam_NU_SabteAgahiBottomGridInput2'></input>
          </div>
        </div>
        <div className='BaaHam_NU_SabteAgahiBottomGrid'>
              <span className='BaaHam_NU_SabteAgahiBottomGridTitle BaaHam_NU_SabteAgahiBottomGridTitleExact'>توضیحات آگهی <span className='BaaHam_NU_ProfileInputTitleStar'>*</span></span>
              <span className='BaaHam_NU_SabteAgahiBottomGridDescribe'>در توضیحات آگهی به مواردی مانند شرایط اجاره، جزئیات و ویژگی های قابل توجه، دسترسی های محلی و موقعیت قرارگیری ملک اشاره کنید.</span>
              <div className='InputExactContainerForBackTextArea InputExactContainerForBackTextAreaSabteAgahi2'>
               <textarea id="description"   className='BaaHam_NU_ProfileTextArea' />
              </div>
        </div>
        <div className="labelLSGN" id="labelLSGNDialogWait" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
            لطفا کمی صبر کنید ...
        </div>
        <div className="labelLSGN" id="labelLSGNDialogOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#06d6a0", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
            آگهی مورد نظر با موفقیت ثبت شد
        </div>
        <div className="labelLSGN" id="labelLSGNDialogErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
            --
        </div>
        <div className='BaaHam_NU_SabteAgahiBottomButtons'>
          <div className='BaaHam_NU_SabteAgahiBottomButton BaaHam_NU_SabteAgahiBottomButton2'> 
            <span>انصراف</span>
          </div>
          <div className='BaaHam_NU_SabteAgahiBottomButton ' onClick={regAgahi}>
            <span>ارسال آگهی</span>
          </div>
        </div>
        <div className='BaaHam_NU_SabteAgahiFooter'>
          <div className='BaaHam_NU_SabteAgahiFooterTitle'>
            <span>اگهی های قبلی</span>
          </div>
          <div className='BaaHam_NU_SabteAgahiFooter3Last3'>
              <div className='BaaHam_NU_SabteAgahiFooter3Last'>
                  <div className='BaaHam_NU_SabteAgahiFooter3LastImageContainer'>
                    <img alt="hi" src={image1} className='BaaHam_NU_SabteAgahiFooter3LastImage'/>
                  </div>
                  <div className='BaaHam_NU_SabteAgahiFooter3LastTitleDescribe'>
                    <span className='BaaHam_NU_SabteAgahiFooter3LastTitle'>عنوان</span>
                    <span className='BaaHam_NU_SabteAgahiFooter3LastDescribe'>توضیح کوتاه</span>
                  </div>
              </div>
              <div className='BaaHam_NU_SabteAgahiFooter3Last'>
                  <div className='BaaHam_NU_SabteAgahiFooter3LastImageContainer'>
                    <img alt="hi" src={image1} className='BaaHam_NU_SabteAgahiFooter3LastImage' />
                  </div>
                  <div className='BaaHam_NU_SabteAgahiFooter3LastTitleDescribe'>
                    <span className='BaaHam_NU_SabteAgahiFooter3LastTitle'>عنوان</span>
                    <span className='BaaHam_NU_SabteAgahiFooter3LastDescribe'>توضیح کوتاه</span>
                  </div>
              </div>
              <div className='BaaHam_NU_SabteAgahiFooter3Last'>
                  <div className='BaaHam_NU_SabteAgahiFooter3LastImageContainer'>
                    <img alt="hi" src={image1} className='BaaHam_NU_SabteAgahiFooter3LastImage'/>
                  </div>
                  <div className='BaaHam_NU_SabteAgahiFooter3LastTitleDescribe'>
                    <span className='BaaHam_NU_SabteAgahiFooter3LastTitle'>عنوان</span>
                    <span className='BaaHam_NU_SabteAgahiFooter3LastDescribe'>توضیح کوتاه</span>
                  </div>
              </div>
          </div>
        </div>
    </div>
  )
}

export default BaaHam_NormalUsers_SabteAgahi